import { useLang } from "@/lib/i18n";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center font-display font-extrabold uppercase text-5xl sm:text-7xl lg:text-8xl px-6 sm:px-10 whitespace-nowrap">
        {w}
        <img src="/img/logo.png" alt="" aria-hidden="true" className="w-10 h-10 sm:w-16 sm:h-16 ml-12 sm:ml-20 object-contain" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
  <section data-testid="editorial-marquee" className="relative border-y border-[var(--line)] py-8 sm:py-12 overflow-hidden bg-[var(--ink-2)]">
    <div className="marquee-track flex w-max text-[var(--bone)]/90">
      <Row words={t("marquee")} /><Row words={t("marquee")} />
    </div>
  </section>
  );
};
